'use strict';

export default class ParagraphTypeWebform {
  constructor() {
    this.name = 'paragraph--type--webform';

    let webforms = $(".paragraph--type--webform, .paragraph--type--donation-form");
    let self = this;
    webforms.each(function(k, webform) {
      self.initWebform($(webform));
    })
    
  }

  initWebform(webform) {
    if(webform.find(">.webform-wrapper .field--name-field-image").length) {
      webform.addClass("webform-two-col");
    }
  }
}
